import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Customer } from '../model/customer';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpCustomService } from 'src/service/http-custom.service';
import { API } from '../apis/api';


@Injectable()
export class CustomerResolver implements Resolve<Customer> {
  constructor(private http: HttpCustomService) {}
  customerNo: string;
  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> {
    this.customerNo = route.params.customerNo;
    return this.http.get({
      path: API.CUSTOMER_DETAIL,
      bind: {
        customerNo: {
          name: 'customerNo',
          placeholder: ':customerNo'
        },
      },
      values: {
        customerNo: this.customerNo,
      }
    });
  }
}
